import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient , HttpHeaders } from '@angular/common/http';
import { Observable , throwError  } from 'rxjs';
import { Usuario } from '../model/usuario'
import { retry , catchError } from 'rxjs/operators';
import { JardinModel} from '../model/Jardin.model'
import { CuentaUsuarioModel, CuentaJardinPeriodoModel, EncargadoRegionalModel } from '../model/Cuentas.model';
import { StorageService } from './storage.service';
import { environment } from 'src/environments/environment';
import { ProyectoEducativoContextoDataModel, ProyectoEducativoDataModel, ProyectoEducativoFechasActualizacionModel,ProyectoEducativoEvaluacionDataModel, ProyectoEducativoIdearioDataModel, ProyectoEducativoObjetivosDataModel } from '../model/ProyectoEducativoData.model';
import { CuentasJardinCronogramaModel } from '../model/JardinCronograma.model';
import { BlockNotasModel } from '../model/BlockNotas.model';
import { EvaluacionContextoModel } from '../model/AutoevaluacionContexto.model';

const login = 'usuario/login';
const jardin = 'jardin/jardin/';
const jardin2023 = 'jardin/jardin2023/';
const jardin2024 = 'jardin/jardin2024/';
const jardin2025 = 'jardin/jardin2025/';
const obtenerJardinEquipo = 'jardin/obtenerJardinEquipo/';
const jardinByRBD = 'jardin/jardinByRBD/';
const activarJardin = 'jardin/activarPEI/';
const jardinName = 'jardin/';
const cambiarContraseña = 'usuario/cambiarPassword/';
const bloquearUsuario = 'usuario/bloquearUsuario/';
const imprimirProyectoEducativo = 'jardin/imprimirProyectoEducativo/';
const unidadEducatica = 'jardin/unidadeducativa/';
const historial = 'jardin/historial/';
const obtenerDetalleEstadoUE = 'jardin/obtenerDetalleEstadoUE/';
const unidadEducaticaProyecto = 'jardin/unidadeducativaproyeto/';
const finalizarProyectoEducativo = 'jardin/finalizarProyectoEducativo/';
const directora = 'jardin/directora/';
const equipoPedagogico = 'jardin/equipoPedagogico/';
const estamentos = 'jardin/estamentos/';
const buscarMiembro = 'jardin/buscarMiembro/';
const crearMiembro = 'jardin/crearMiembro/';
const editarMiembro = 'jardin/editarMiembro';
const eliminarMiembro = 'jardin/eliminarMiembro/';
const getPerdonaByIdUsuario = 'jardin/getPersonaByIdUsuario/';

const actualizarFotoPerfil = 'usuario/actualizarFotoPerfil/';
const obtenerFotoPerfil = 'usuario/obtenerFotoPerfil/';

const mediosVerificacion = 'jardin/mediosVerificacion/';
const guardarMediosVerificacion = 'jardin/insertMedioVerificacion/';
const eliminarMediosVerificacion = 'jardin/deleteMedioVerificacion/';
const descargarMediosVerificacion = 'jardin/descargarMedioVerificacion/';
const crearConsulta = 'jardin/crearConsulta/';

const crearBlockNota = 'jardin/crearBlockNota/';
const deleteBlockNota = 'jardin/deleteBlockNota/';
const actualizarBlockNota = 'jardin/actualizarBlockNota';

const crearForo = 'foro/crearForo/';
const obtenerForo = 'foro/getForos/';
const obtenerDetalleForo = 'foro/getRespuestasForo/';
const crearRespuesta = 'foro/crearRespuesta/';

const resumenIntentos = 'evaluacion/getResumenIntentos/';
const nuevaEvaluacion = 'evaluacion/getNuevaEvaluacion/';
const guardarEvaluacion = 'evaluacion/guardarEvaluacion/';
const obtenerCertificado = 'evaluacion/obtenerCertificado/';

const autoevaluacion = 'autoEvaluacion/getAutoEvaluacion/';
const guardarRespuestaAutoevaluacion = 'autoEvaluacion/guardarRespuesta/';
const vincularMedioAutoevaluacion = 'autoEvaluacion/vincularMedio/';
const eliminarVinculacionMedioAutoevaluacion = 'autoEvaluacion/eliminarVinculacionMedio/';
const finalizarAutoevaluacion = 'autoEvaluacion/finalizarAutoEvaluacion/';
const getEvaluacionContexto = 'autoEvaluacion/getEvaluacionContexto/';
const finalizarEvaluacionContexto = 'autoEvaluacion/finalizarEvaluacionContexto/';
const guardarEvaluacionContexto = 'autoEvaluacion/guardarEvaluacionContexto/';
const getApelacionJardin = 'jardin/getApelacionJardin/';
const guardarElementoApelacion = 'jardin/guardarElementoApelacion/';


const getCuentasJardinAdminConsolidado = 'adminUsuario/getCuentasJardinAdminConsolidado/';
const getCuentasJardinAdmin = 'adminUsuario/getCuentasJardinAdmin/';
const cuentasJardinCronograma = 'adminUsuario/getCuentasJardinCronograma/';
const abrirPlanMejora = 'adminUsuario/abrirPlanMejora/';

const otrasCuentas = 'adminUsuario/getOtrasCuentas/';
const encargadosRegionales = 'adminUsuario/getEncargadosRegionales/';
const selectCuentas = 'adminUsuario/getSelectCuentas/';
const getEditarCuentaJardin = 'adminUsuario/getEditarCuentaJardin/';
const guardarCuentaJardin = 'adminUsuario/editarCuentaJardin/';
const crearCuentaUsuario = 'adminUsuario/crearCuentaUsuario/';
const buscarPersona = 'adminUsuario/buscarPersona/';
const buscarCodigo = 'adminUsuario/buscarRbd/';
const getResumenAutoevaluacionRegion = 'adminUsuario/getResumenAutoevaluacionRegion';
const getResumenAutoevaluacionPrograma = 'adminUsuario/getResumenAutoevaluacionPrograma';
const getResumenValidacionRegion = 'adminUsuario/getResumenValidacionRegion';
const getResumenValidacionPrograma = 'adminUsuario/getResumenValidacionPrograma';
const getResumenPlanMejoraRegion = 'adminUsuario/getResumenPlanMejoraRegion';
const getResumenPlanMejoraPrograma = 'adminUsuario/getResumenPlanMejoraPrograma';
const getCapacitacionDistancia = 'adminUsuario/getCapacitacionDistancia';
const getCapacitacionTutorias = 'adminUsuario/getCapacitacionTutorias';
const getAutoevaluacionDetalle = 'adminUsuario/getAutoevaluacionDetalle';
const getValidacionDetalle = 'adminUsuario/getValidacionDetalle';
const getApelacionDetalle = 'adminUsuario/getApelacionDetalle';
const getPlanMejoraDetalle = 'adminUsuario/getPlanMejoraDetalle';
const getProyectoEducativoDetalle = 'adminUsuario/getProyectoEducativoDetalle';
const getPlanGestionConvivenciaDetalle = 'adminUsuario/getPlanGestionConvivenciaDetalle';
const getInstrumentoAutoevaluacionDetalle = 'adminUsuario/getInstrumentoAutoevaluacionDetalle';
const getReglamentoInternoDetalle = 'adminUsuario/getReglamentoInternoDetalle';
const getBibliotecaDetalle = 'adminUsuario/getReglamentoInternoDetalle';
const getNewPlanMejoraDetalle = 'adminUsuario/getNewPlanMejoraDetalle';


const obtenerTodasLasConsultas = 'adminvalidacion/getTodasConsultasPendientesPeriodoActual';
const jardinPorIdJrdinPeriodo = 'jardin/jardinPorIdJardinPeriodo/';
const actualizarConsulta = 'adminvalidacion/actualizarConsulta';
const guardarAsesorTecnico = 'adminUsuario/guardarAsesorTecnico';

const getEtapasPlanMejoraJardin = 'planMejora/getEtapasPlanMejoraJardin/';
const getRegionByIdUsuario = 'adminUsuario/getRegionByIdUsuario/';
const guardarArchivoBiblioteca = 'biblioteca/cargarArchivo';
const eliminarArchivoBiblioteca = 'biblioteca/eliminarArchivo/';

const descargarInstrumentoAutoEvaluacion = 'instrumentoAutoevaluacion/descargar/';
const obtenerParametroRI = 'parametros/parametroRI';
const cambiarParametroRI = 'parametros/cambiarParametroRI/';
const activarRI = 'reglamentoInterno/activarRI/';
const recuperarPassword = 'adminUsuario/recuperarPasswword/';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'Authorization': 'Basic ' + btoa('croamora:cristianroa.123')
  })
  
};  
const httpPDFOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'application/pdf',
    'Authorization': 'Basic ' + btoa('croamora:cristianroa.123')
  })
  
}; 
const httpOptionsFile = {

  headers: new HttpHeaders({    
    'Authorization': 'Basic ' + btoa('croamora:cristianroa.123')
  })
}; 
@Injectable({
  providedIn: 'root'
})


export class apiService {
 


 
  public dataJardin = new JardinModel(); 
  public dataJardin2023 = new JardinModel(); 
  public dataJardin2024 = new JardinModel();
  public dataJardin2025 = new JardinModel();

  direccionar = new EventEmitter<string>();
  cargando = new EventEmitter<boolean>();

  idForo; 
  activeTabContacto = 0;
  activeTabEtapa = 0;
  constructor(private http:HttpClient,private storageService: StorageService) { }


  API_POST_login(usuario : Usuario): Observable<any>{    
         
    return this.http.post<Usuario>(environment.apiEndpoint + login, usuario, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  API_POST_obtenerJardin(id:number): Observable<any>{    
             
    return this.http.post(environment.apiEndpoint + jardin +id, null, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  API_POST_obtenerJardin2023(id:number): Observable<any>{    
             
    return this.http.post(environment.apiEndpoint + jardin2023 +id, null, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  API_POST_obtenerJardin2024(id:number): Observable<any>{    
             
    return this.http.post(environment.apiEndpoint + jardin2024 +id, null, httpOptions).pipe(
      catchError(this.handleError)
    );
  }
    API_POST_obtenerJardin2025(id:number): Observable<any>{    
             
    return this.http.post(environment.apiEndpoint + jardin2025 +id, null, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  API_POST_obtenerJardinEquipo(id: any) {
    return this.http.post(environment.apiEndpoint + obtenerJardinEquipo +id, null, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  API_POST_obtenerJardinPorRBD(rbd:number): Observable<any>{    
             
    return this.http.post(environment.apiEndpoint + jardinByRBD +rbd, null, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  API_POST_activarJardin(idJardinPeriodo:number){    
             
    return this.http.post(environment.apiEndpoint + activarJardin +idJardinPeriodo, null, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  API_POST_getPersonaEquipo(id: any) {
    return this.http.post(environment.apiEndpoint + getPerdonaByIdUsuario +id, null, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  API_POST_cambiarPass(json){
     
    return this.http.post(environment.apiEndpoint + cambiarContraseña, json, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  API_POST_bloquearUsuario(idUsuario: number, tipoUsuario: string){
     
    return this.http.post(environment.apiEndpoint + bloquearUsuario + '?id='+idUsuario+'&tipoUsuario='+tipoUsuario, null, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  API_POST_AbrirPlanMejora(id: number){
    return this.http.post(environment.apiEndpoint + abrirPlanMejora + id, null, httpOptions).pipe(
      catchError(this.handleError)
    );
  }
   
  //MODULO IDENTIFICACION
    API_POST_obtenerUnidadEducatica(id:number): Observable<any>{              
      return this.http.post(environment.apiEndpoint + unidadEducatica +id, null, httpOptions).pipe(
        catchError(this.handleError)
      );
    }
    
    API_POST_obtenerHistorial(rbd: string): Observable<any>{ 
      return this.http.post(environment.apiEndpoint + historial + rbd, null, httpOptions).pipe(
        catchError(this.handleError)
      );
    }

    API_POST_obtenerDetalleEstadoUE(idJardinPeriodo: number) {
      return this.http.post(environment.apiEndpoint + obtenerDetalleEstadoUE + idJardinPeriodo, null, httpOptions).pipe(
        catchError(this.handleError)
      );
    }

    API_POST_obtenerUnidadEducaticaProyecto(id:number): Observable<any>{    
      return this.http.post(environment.apiEndpoint + unidadEducaticaProyecto +id, null, httpOptions).pipe(
        catchError(this.handleError)
      );
    }

    API_POST_finalizarProyecto(id:number): Observable<any>{    
      return this.http.post(environment.apiEndpoint + finalizarProyectoEducativo + id, null, httpOptions).pipe(
        catchError(this.handleError)
      );
    }

    API_POST_obtenerProyectoEducativoData(id: number) {
      return this.http.post(environment.apiEndpoint + jardinName + id + '/proyectoEducativo', null, httpOptions).pipe(
        catchError(this.handleError)
      );
      
    }

    API_GET_imprimirProyectoEducativo(idJardinPeriodo: number) {
      return this.http.get(environment.apiEndpoint + imprimirProyectoEducativo + idJardinPeriodo , httpPDFOptions).pipe(
        catchError(this.handleError)
      );
    }

    downLoadFile(data: any, type: string) {
      let blob = new Blob([data], { type: type});
      let url = window.URL.createObjectURL(blob);
      let pwa = window.open(url);
      if (!pwa || pwa.closed || typeof pwa.closed == 'undefined') {
          alert( 'Please disable your Pop-up blocker and try again.');
      }
  }

    API_POST_obtenerProyectoEducativoContextoData(id: number) {
      return this.http.post(environment.apiEndpoint + jardinName + id + '/proyectoEducativoContexto', null, httpOptions).pipe(
        catchError(this.handleError)
      );
    }

    API_POST_obtenerProyectoEducativoIdearioData(id: number) {
      return this.http.post(environment.apiEndpoint + jardinName + id + '/proyectoEducativoIdeario', null, httpOptions).pipe(
        catchError(this.handleError)
      );
    }

    API_POST_obtenerProyectoEducativoObjectivosData(id: number) {
      return this.http.post(environment.apiEndpoint + jardinName + id + '/proyectoEducativoObjetivos', null, httpOptions).pipe(
        catchError(this.handleError)
      );
    }

    API_POST_obtenerProyectoEducativoEvaluacionData(id: number) {
      return this.http.post(environment.apiEndpoint + jardinName + id + '/proyectoEducativoEvaluacion', null, httpOptions).pipe(
        catchError(this.handleError)
      );
    }

    API_POST_actualizarProyectoEducativoData(proyectoEducativoData: ProyectoEducativoDataModel) {
      return this.http.post(environment.apiEndpoint + jardinName + 'proyectoEducativo/actualizar', proyectoEducativoData, httpOptions).pipe(
        catchError(this.handleError)
      );
      
    }

    API_POST_actualizarProyectoEducativoContextoData(proyectoEducativoContextoDataModel: ProyectoEducativoContextoDataModel) {
      return this.http.post(environment.apiEndpoint + jardinName + 'proyectoEducativo/actualizarContexto', proyectoEducativoContextoDataModel, httpOptions).pipe(
        catchError(this.handleError)
      );
    }

    API_POST_actualizarProyectoEducativoIdearioData(proyectoEducativoIdearioDataModel: ProyectoEducativoIdearioDataModel) {
      return this.http.post(environment.apiEndpoint + jardinName + 'proyectoEducativo/actualizarIdeario', proyectoEducativoIdearioDataModel, httpOptions).pipe(
        catchError(this.handleError)
      );
    }

    API_POST_actualizarProyectoEducativoObjetivosData(proyectoEducativoObjetivosDataModel: ProyectoEducativoObjetivosDataModel) {
      return this.http.post(environment.apiEndpoint + jardinName + 'proyectoEducativo/actualizarObjetivos', proyectoEducativoObjetivosDataModel, httpOptions).pipe(
        catchError(this.handleError)
      );
    }

    API_POST_actualizarProyectoEducativoEvaluacionData(proyectoEducativoEvaluacionDataModel: ProyectoEducativoEvaluacionDataModel) {
      return this.http.post(environment.apiEndpoint + jardinName + 'proyectoEducativo/actualizarEvaluacion', proyectoEducativoEvaluacionDataModel, httpOptions).pipe(
        catchError(this.handleError)
      );
    }
    

    API_POST_getEvaluacionContexto(idJardinPeriodo: number) {
      return this.http.post(environment.apiEndpoint + getEvaluacionContexto + idJardinPeriodo, null, httpOptions).pipe(
        catchError(this.handleError)
      );
    }

    API_POST_finalizarEvaluacionContexto(evaluacionContextoModel: EvaluacionContextoModel) {
      return this.http.post(environment.apiEndpoint + finalizarEvaluacionContexto, evaluacionContextoModel, httpOptions).pipe(
        catchError(this.handleError)
      );
    }

    API_POST_obtenerDirectora(id:number): Observable<any>{    
              
      return this.http.post(environment.apiEndpoint + directora +id, null, httpOptions).pipe(
        catchError(this.handleError)
      );
    }

    API_POST_obtenerEquipoPedagogico(id:number): Observable<any>{    
              
      return this.http.post(environment.apiEndpoint + equipoPedagogico +id, null, httpOptions).pipe(
        catchError(this.handleError)
      );
    }

    API_POST_obtenerEstamentos(): Observable<any>{    
              
      return this.http.post(environment.apiEndpoint + estamentos, null, httpOptions).pipe(
        catchError(this.handleError)
      );
    }

    API_POST_buscarMiembro(rut:string): Observable<any>{    
              
      return this.http.post(environment.apiEndpoint + buscarMiembro+rut+','+this.dataJardin.id, null, httpOptions).pipe(
        catchError(this.handleError)
      );
    }

    API_POST_nuevoMiembro(json:any): Observable<any>{    
          
      return this.http.post<Usuario>(environment.apiEndpoint + crearMiembro, json, httpOptions).pipe(
        catchError(this.handleError)
      );
    }

    API_POST_editarMiembro(json:any): Observable<any>{    
          
      return this.http.post<Usuario>(environment.apiEndpoint + editarMiembro, json, httpOptions).pipe(
        catchError(this.handleError)
      );
    }

    API_POST_eliminarMiembro(idPersona:number): Observable<any>{    
          
      return this.http.post<Usuario>(environment.apiEndpoint + eliminarMiembro + idPersona + ',' + this.dataJardin.id, null, httpOptions).pipe(
        catchError(this.handleError)
      );
    }


    API_POST_actualizarFotoPerfil(archivo): Observable<any>{    
              
      return this.http.post(environment.apiEndpoint + actualizarFotoPerfil , archivo, httpOptionsFile).pipe(
        catchError(this.handleError)
      );
    }

    API_POST_obtenerFotoPerfil(idUsuario: string): Observable<any>{    
            
      return this.http.post(environment.apiEndpoint + obtenerFotoPerfil + idUsuario , null, httpOptionsFile).pipe(
        catchError(this.handleError)
      );
    }

    API_POST_getEtapasPlanMejoraJardin(idUsuario: number): Observable<any>{
      return this.http.post(environment.apiEndpoint + getEtapasPlanMejoraJardin + idUsuario, httpOptions).pipe(
        catchError(this.handleError)
      );
    }

    API_GET_getRegionByIdUsuario(idUsuario: string) {
      return this.http.get(environment.apiEndpoint + getRegionByIdUsuario + idUsuario, httpOptions).pipe(
        catchError(this.handleError)
      );
    }


  //MEDIOS DE VERIFICACION
    API_POST_obtenerMediosVerificacion(id:number): Observable<any>{    
              
      return this.http.post(environment.apiEndpoint + mediosVerificacion + id, null, httpOptions).pipe(
        catchError(this.handleError)
      );
    }

    API_POST_guardarMediosVerificacion(archivo): Observable<any>{    
              
      return this.http.post(environment.apiEndpoint + guardarMediosVerificacion , archivo, httpOptionsFile).pipe(
        catchError(this.handleError)
      );
    }

    API_POST_eliminarMediosVerificacion(id:number): Observable<any>{    
              
      return this.http.post(environment.apiEndpoint + eliminarMediosVerificacion + id, null, httpOptions).pipe(
        catchError(this.handleError)
      );
    }

    API_POST_descargarMediosVerificacion(id:number): Observable<any>{    
              
      return this.http.post(environment.apiEndpoint + descargarMediosVerificacion + id, null, httpOptions).pipe(
        catchError(this.handleError)
      );
    }
   

    

    API_POST_crearBlockNota(blockNotasModel : BlockNotasModel): Observable<any>{          
      return this.http.post(environment.apiEndpoint + crearBlockNota , blockNotasModel, httpOptions).pipe(
        catchError(this.handleError)
      );
    }

    API_POST_actualizarBlockNota(blockNotasModel : BlockNotasModel): Observable<any>{          
      return this.http.post(environment.apiEndpoint + actualizarBlockNota , blockNotasModel, httpOptions).pipe(
        catchError(this.handleError)
      );
    }

    API_POST_getMisBlockNotas(): Observable<any>{    
      return this.http.post(environment.apiEndpoint + "jardin/" + this.dataJardin.id + "/getMisBlockNotas"  , null, httpOptions).pipe(
        catchError(this.handleError)
      );
    }

    API_POST_deleteBlockNota(blockNotasModel : BlockNotasModel): Observable<any>{    
      return this.http.post(environment.apiEndpoint + deleteBlockNota , blockNotasModel, httpOptions).pipe(
        catchError(this.handleError)
      );
    }


  // MODULO CONTANTO
    API_POST_crearConsulta(json): Observable<any>{    
              
      return this.http.post(environment.apiEndpoint + crearConsulta , json, httpOptions).pipe(
        catchError(this.handleError)
      );
    }

    API_POST_obtenerMisConsultas(): Observable<any>{    
        
      return this.http.post(environment.apiEndpoint + "jardin/" + this.dataJardin.id + "/getMisConsultas"  , null, httpOptions).pipe(
        catchError(this.handleError)
      );
    }

    API_POST_crearForo(json): Observable<any>{    
              
      return this.http.post(environment.apiEndpoint + crearForo , json, httpOptions).pipe(
        catchError(this.handleError)
      );
    }
  
    API_POST_obtenerForo(): Observable<any>{    
              
      return this.http.post(environment.apiEndpoint + obtenerForo, null, httpOptions).pipe(
        catchError(this.handleError)
      );
    }
    
    API_POST_obtenerDetalleForo(): Observable<any>{    
              
      return this.http.post(environment.apiEndpoint + obtenerDetalleForo + this.idForo, null, httpOptions).pipe(
        catchError(this.handleError)
      );
    }

    API_POST_enviarRespuestaForo(json): Observable<any>{    
              
      return this.http.post(environment.apiEndpoint + crearRespuesta, json, httpOptions).pipe(
        catchError(this.handleError)
      );
    }
  

  //MODULO ETAPAS
    API_POST_obtenerResumenIntentos(): Observable<any>{    
              
      return this.http.post(environment.apiEndpoint + resumenIntentos + this.storageService.getCurrentUser().idUsuario + ','+ this.dataJardin.id, null, httpOptions).pipe(
        catchError(this.handleError)
      );
    }

    API_POST_obtenerEvaluacion(): Observable<any>{    
              
      return this.http.post(environment.apiEndpoint + nuevaEvaluacion, null, httpOptions).pipe(
        catchError(this.handleError)
      );
    }
    
    API_POST_enviarEvaluacion(json): Observable<any>{    
              
      return this.http.post(environment.apiEndpoint + guardarEvaluacion, json, httpOptions).pipe(
        catchError(this.handleError)
      );
    }
   
    API_POST_obtenerAutoevaluacion(): Observable<any>{    
              
      return this.http.post(environment.apiEndpoint + autoevaluacion + this.dataJardin.id + ','+ this.storageService.getCurrentUser().idUsuario, null, httpOptions).pipe(
        catchError(this.handleError)
      );
    }

    API_POST_getApelacionJardin(): Observable<any> {
       return this.http.post(environment.apiEndpoint + getApelacionJardin + this.dataJardin.id + ','+ this.storageService.getCurrentUser().idUsuario, null, httpOptions).pipe(
        catchError(this.handleError)
      );
    }

    API_POST_guardarElementoApelacion(elemento: any): Observable<any> {
      return this.http.post(environment.apiEndpoint + guardarElementoApelacion , elemento, httpOptions).pipe(
        catchError(this.handleError)
      );
    }

    API_POST_guardarRespuestaAutoevaluacion(idRetroalimentacion): Observable<any>{    
              
      return this.http.post(environment.apiEndpoint +  guardarRespuestaAutoevaluacion + this.dataJardin.id + ',' + idRetroalimentacion, null, httpOptions).pipe(
        catchError(this.handleError)
      );
    }

    API_POST_vincularMedioAutoevaluacion(json): Observable<any>{    
              
      return this.http.post(environment.apiEndpoint + vincularMedioAutoevaluacion, json, httpOptions).pipe(
        catchError(this.handleError)
      );
    }

    API_POST_eliminarVinculacionMedioAutoevaluacion(id): Observable<any>{    
              
      return this.http.post(environment.apiEndpoint + eliminarVinculacionMedioAutoevaluacion + id, null, httpOptions).pipe(
        catchError(this.handleError)
      );
    }
    
    API_POST_finalizarAutoEvaluacion(): Observable<any>{    
              
      return this.http.post(environment.apiEndpoint + finalizarAutoevaluacion + this.dataJardin.id, null, httpOptions).pipe(
        catchError(this.handleError)
      );
    }

    API_POST_obtenerCertificado(): Observable<any>{    
              
      return this.http.post(environment.apiEndpoint + obtenerCertificado + this.storageService.getCurrentUser().idUsuario, null, httpOptions).pipe(
        catchError(this.handleError)
      );
    }

    API_POST_getCuentasJardinAdmin(pageNum,pageSize,palabraClave,idRegion,idComuna,idPrograma): Observable<any>{    
      return this.http.post(environment.apiEndpoint + getCuentasJardinAdmin + '?pageNum='+pageNum+'&pageSize='+pageSize+
                            '&palabraClave='+palabraClave +'&idRegion='+idRegion+'&idComuna='+idComuna+'&idPrograma='+idPrograma, null, httpOptions).pipe(
        catchError(this.handleError)
      );
    }

    API_POST_getCuentasJardinAdminConsolidado(pageNum,pageSize,palabraClave,idRegion,idComuna,idPrograma): Observable<any>{    
      return this.http.post(environment.apiEndpoint + getCuentasJardinAdminConsolidado + '?pageNum='+pageNum+'&pageSize='+pageSize+
                            '&palabraClave='+palabraClave +'&idRegion='+idRegion+'&idComuna='+idComuna+'&idPrograma='+idPrograma, null, httpOptions).pipe(
        catchError(this.handleError)
      );
    }
    


    API_POST_getCuentasJardinCronograma(pageNum,pageSize,palabraClave,idRegion,idComuna,idPrograma): Observable<any>{    
      return this.http.post(environment.apiEndpoint + cuentasJardinCronograma + '?pageNum='+pageNum+'&pageSize='+pageSize+
      '&palabraClave='+palabraClave +'&idRegion='+idRegion+'&idComuna='+idComuna+'&idPrograma='+idPrograma, null, httpOptions).pipe(
        catchError(this.handleError)
      );
    }

    API_POST_getOtrasCuentas(pageNum,pageSize,palabraClave,idRegion,idComuna,idPrograma): Observable<any>{          
      return this.http.post(environment.apiEndpoint + otrasCuentas+ '?pageNum='+pageNum+'&pageSize='+pageSize+
      '&palabraClave='+palabraClave +'&idRegion='+idRegion+'&idComuna='+idComuna+'&idPrograma='+idPrograma, null, httpOptions).pipe(
        catchError(this.handleError)
      );
    }

    API_POST_getEncargadosRegionales(pageNum,pageSize,palabraClave,idRegion,idComuna,idPrograma): Observable<any>{          
      return this.http.post(environment.apiEndpoint + encargadosRegionales+ '?pageNum='+pageNum+'&pageSize='+pageSize+
      '&palabraClave='+palabraClave +'&idRegion='+idRegion+'&idComuna='+idComuna+'&idPrograma='+idPrograma, null, httpOptions).pipe(
        catchError(this.handleError)
      );
    }
     
    API_POST_updateFechaCapacitacion(cuentasJardinCronogramaModel: CuentasJardinCronogramaModel): Observable<any>{ 
      return this.http.post(environment.apiEndpoint + "adminUsuario/updateFechaCapacitacion", cuentasJardinCronogramaModel, httpOptions).pipe(
        catchError(this.handleError)
      );
    }

    API_POST_updateFechaInicioAutoevaluacion(cuentasJardinCronogramaModel: CuentasJardinCronogramaModel): Observable<any>{ 
      return this.http.post(environment.apiEndpoint + "adminUsuario/updateFechaInicioAutoevaluacion", cuentasJardinCronogramaModel, httpOptions).pipe(
        catchError(this.handleError)
      );
    }

    API_POST_getSelectCuentas(): Observable<any>{    
      return this.http.post(environment.apiEndpoint + selectCuentas, null, httpOptions).pipe(
        catchError(this.handleError)
      );
    }

    API_POST_editarCuentaJardin(idCuentaJardin): Observable<any>{    
      return this.http.post(environment.apiEndpoint + getEditarCuentaJardin + idCuentaJardin, null, httpOptions).pipe(
        catchError(this.handleError)
      );
    }
     
    API_POST_guardarCuentaJardin(cuenta: CuentaJardinPeriodoModel): Observable<any>{            
      return this.http.post(environment.apiEndpoint + guardarCuentaJardin, cuenta, httpOptions).pipe(
        catchError(this.handleError)
      );
    }

    API_POST_crearCuentaUsuario(usuario:CuentaUsuarioModel): Observable<any>{         
      return this.http.post(environment.apiEndpoint + crearCuentaUsuario, usuario, httpOptions).pipe(
        catchError(this.handleError)
      );
    }

    API_POST_buscarPersona(rut:string): Observable<any>{       
      return this.http.post(environment.apiEndpoint + buscarPersona + rut, null, httpOptions).pipe(
        catchError(this.handleError)
      );
    }
     
    API_POST_buscarCodigo(codigo:string): Observable<any>{          
      return this.http.post(environment.apiEndpoint + buscarCodigo + codigo, null, httpOptions).pipe(
        catchError(this.handleError)
      );
    }

    API_POST_getResumenAutoevaluacionRegion(): Observable<any> {
      return this.http.post(environment.apiEndpoint + getResumenAutoevaluacionRegion , null, httpOptions).pipe(
        catchError(this.handleError)
      );
    }
    
    API_POST_getResumenAutoevaluacionPrograma(): Observable<any>{
      return this.http.post(environment.apiEndpoint + getResumenAutoevaluacionPrograma , null, httpOptions).pipe(
        catchError(this.handleError)
      );
    }

    API_POST_getResumenValidacionRegion(): Observable<any> {
      return this.http.post(environment.apiEndpoint + getResumenValidacionRegion , null, httpOptions).pipe(
        catchError(this.handleError)
      );
    }
    API_POST_getResumenValidacionPrograma(): Observable<any> {
      return this.http.post(environment.apiEndpoint + getResumenValidacionPrograma , null, httpOptions).pipe(
        catchError(this.handleError)
      );
    }

    API_POST_getResumenPlanMejoraRegion(): Observable<any> {
      return this.http.post(environment.apiEndpoint + getResumenPlanMejoraRegion , null, httpOptions).pipe(
        catchError(this.handleError)
      );
    }
    API_POST_getResumenPlanMejoraPrograma(): Observable<any> {
      return this.http.post(environment.apiEndpoint + getResumenPlanMejoraPrograma , null, httpOptions).pipe(
        catchError(this.handleError)
      );
    }


    API_POST_getCapacitacionDistancia(pageNum: number, pageSize: number, palabraClave: string, idRegion: number, idComuna: number, idPrograma: number) : Observable<any>{
      return this.http.post(environment.apiEndpoint + getCapacitacionDistancia + '?pageNum='+pageNum+'&pageSize='+pageSize+
            '&palabraClave='+palabraClave +'&idRegion='+idRegion+'&idComuna='+idComuna+'&idPrograma='+idPrograma, null, httpOptions).pipe(
      catchError(this.handleError)
      );
    }

    API_POST_getCapacitacionTutorias(pageNum: number, pageSize: number, palabraClave: string, idRegion: number, idComuna: number, idPrograma: number) : Observable<any>{
      return this.http.post(environment.apiEndpoint + getCapacitacionTutorias + '?pageNum='+pageNum+'&pageSize='+pageSize+
            '&palabraClave='+palabraClave +'&idRegion='+idRegion+'&idComuna='+idComuna+'&idPrograma='+idPrograma, null, httpOptions).pipe(
      catchError(this.handleError)
      );
    }

    API_POST_getAutoevaluacionDetalle(pageNum: number, pageSize: number, palabraClave: string, idRegion: number, idComuna: number, idPrograma: number) : Observable<any>{
      return this.http.post(environment.apiEndpoint + getAutoevaluacionDetalle + '?pageNum='+pageNum+'&pageSize='+pageSize+
            '&palabraClave='+palabraClave +'&idRegion='+idRegion+'&idComuna='+idComuna+'&idPrograma='+idPrograma, null, httpOptions).pipe(
      catchError(this.handleError)
      );
    }

    API_POST_getValidacionDetalle(pageNum: number, pageSize: number, palabraClave: string, idRegion: number, idComuna: number, idPrograma: number) : Observable<any>{
      return this.http.post(environment.apiEndpoint + getValidacionDetalle + '?pageNum='+pageNum+'&pageSize='+pageSize+
            '&palabraClave='+palabraClave +'&idRegion='+idRegion+'&idComuna='+idComuna+'&idPrograma='+idPrograma, null, httpOptions).pipe(
      catchError(this.handleError)
      );
    }

    API_POST_getApelacionDetalle(pageNum: number, pageSize: number, palabraClave: string, idRegion: number, idComuna: number, idPrograma: number) : Observable<any>{
      return this.http.post(environment.apiEndpoint + getApelacionDetalle + '?pageNum='+pageNum+'&pageSize='+pageSize+
            '&palabraClave='+palabraClave +'&idRegion='+idRegion+'&idComuna='+idComuna+'&idPrograma='+idPrograma, null, httpOptions).pipe(
      catchError(this.handleError)
      );
    }

    API_POST_getPlanMejoraDetalle(pageNum: number, pageSize: number, palabraClave: string, idRegion: number, idComuna: number, idPrograma: number) : Observable<any>{
      return this.http.post(environment.apiEndpoint + getPlanMejoraDetalle + '?pageNum='+pageNum+'&pageSize='+pageSize+
            '&palabraClave='+palabraClave +'&idRegion='+idRegion+'&idComuna='+idComuna+'&idPrograma='+idPrograma, null, httpOptions).pipe(
      catchError(this.handleError)
      );
    }

    API_POST_getProyectoEducativoDetalle(pageNum: number, pageSize: number, palabraClave: string, idRegion: number, idComuna: number, idPrograma: number) : Observable<any>{
      return this.http.post(environment.apiEndpoint + getProyectoEducativoDetalle + '?pageNum='+pageNum+'&pageSize='+pageSize+
            '&palabraClave='+palabraClave +'&idRegion='+idRegion+'&idComuna='+idComuna+'&idPrograma='+idPrograma, null, httpOptions).pipe(
      catchError(this.handleError)
      );
    }

    API_POST_getPlanGestionConvivenciaDetalle(pageNum: number, pageSize: number, palabraClave: string, idRegion: number, idComuna: number, idPrograma: number) : Observable<any>{
      return this.http.post(environment.apiEndpoint + getPlanGestionConvivenciaDetalle + '?pageNum='+pageNum+'&pageSize='+pageSize+
            '&palabraClave='+palabraClave +'&idRegion='+idRegion+'&idComuna='+idComuna+'&idPrograma='+idPrograma, null, httpOptions).pipe(
      catchError(this.handleError)
      );
    }

    API_POST_getInstrumentoAutoevaluacionDetalle(pageNum: number, pageSize: number, palabraClave: string, idRegion: number, idComuna: number, idPrograma: number) {
      return this.http.post(environment.apiEndpoint + getInstrumentoAutoevaluacionDetalle + '?pageNum='+pageNum+'&pageSize='+pageSize+
            '&palabraClave='+palabraClave +'&idRegion='+idRegion+'&idComuna='+idComuna+'&idPrograma='+idPrograma, null, httpOptions).pipe(
      catchError(this.handleError)
      );
    }

    API_POST_getReglamentoInternoDetalle(pageNum: number, pageSize: number, palabraClave: string, idRegion: number, idComuna: number, idPrograma: number) : Observable<any>{
      return this.http.post(environment.apiEndpoint + getReglamentoInternoDetalle + '?pageNum='+pageNum+'&pageSize='+pageSize+
            '&palabraClave='+palabraClave +'&idRegion='+idRegion+'&idComuna='+idComuna+'&idPrograma='+idPrograma, null, httpOptions).pipe(
      catchError(this.handleError)
      );
    }

    API_POST_getBibliotecaDetalle(pageNum: number, pageSize: number, palabraClave: string, idRegion: number, idComuna: number, idPrograma: number) : Observable<any>{
      return this.http.post(environment.apiEndpoint + getBibliotecaDetalle + '?pageNum='+pageNum+'&pageSize='+pageSize+
            '&palabraClave='+palabraClave +'&idRegion='+idRegion+'&idComuna='+idComuna+'&idPrograma='+idPrograma, null, httpOptions).pipe(
      catchError(this.handleError)
      );
    }

    API_POST_getNewPlanMejoraDetalle(pageNum: number, pageSize: number, palabraClave: string, idRegion: number, idComuna: number, idPrograma: number) {
      return this.http.post(environment.apiEndpoint + getNewPlanMejoraDetalle + '?pageNum='+pageNum+'&pageSize='+pageSize+
            '&palabraClave='+palabraClave +'&idRegion='+idRegion+'&idComuna='+idComuna+'&idPrograma='+idPrograma, null, httpOptions).pipe(
        catchError(this.handleError)
      );
    }

    API_POST_obtenerTodasLasConsultas(pageNum,pageSize,palabraClave:string): Observable<any>{
      return this.http.post(environment.apiEndpoint + obtenerTodasLasConsultas + '?pageNum='+pageNum+'&pageSize='+pageSize+'&palabraClave='+palabraClave, null, httpOptions).pipe(
        catchError(this.handleError)
      );
    }

    
    API_POST_obtenerJardinPorIdJardinPeriodo(idJardinPeriodo:number): Observable<any>{    
      return this.http.post(environment.apiEndpoint + jardinPorIdJrdinPeriodo +idJardinPeriodo, null, httpOptions).pipe(
        catchError(this.handleError)
      );
    }
    
    API_POST_actualizarConsulta(consulta: any) {
      return this.http.post(environment.apiEndpoint + actualizarConsulta , consulta, httpOptions).pipe(
        catchError(this.handleError)
      );
    }
    
  handleError(error) {    
    let errorMessage = '';
    errorMessage = `Error Code: ${error.status}\nMessage: ${error.error.message}`;
    return throwError(errorMessage);
  }

  getEmitDireccionamiento(){
    return this.direccionar;
  }
  emitDireccionamiento(opcion){
    this.direccionar.emit(opcion);
  }

  // getEmitCargando(){
  //   return this.cargando;
  // }
  // emitCargando(opcion){
  //   this.cargando.emit(opcion);
  // }
  

  API_POST_guardarEvaluacionContexto(evaluacionContextoModel: EvaluacionContextoModel) {
    return this.http.post(environment.apiEndpoint + guardarEvaluacionContexto, evaluacionContextoModel, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  API_POST_guardarAsesorTecnico(encargadoRecionalModel:EncargadoRegionalModel) {
    return this.http.post(environment.apiEndpoint + guardarAsesorTecnico, encargadoRecionalModel, httpOptions).pipe(
      catchError(this.handleError)
    );
  }
  
  API_POST_guardarArchivoBiblioteca(archivo): Observable<any>{
    return this.http.post(environment.apiEndpoint + guardarArchivoBiblioteca , archivo, httpOptionsFile).pipe(
      catchError(this.handleError)
    );
  }

  API_POST_eliminarArchivoBiblioteca(id: number): Observable<any>{
    return this.http.post(environment.apiEndpoint + eliminarArchivoBiblioteca + id , null, httpOptionsFile).pipe(
      catchError(this.handleError)
    );
  }

  API_GET_descargarInstrumentoAutoevaluacion(idJardinPeriodo: number) {
    return this.http.get(environment.apiEndpoint + descargarInstrumentoAutoEvaluacion + idJardinPeriodo , httpPDFOptions).pipe(
        catchError(this.handleError)
    );
  }

  API_GET_downloadExcel(url : string){
    return this.http.get(url,  { responseType: 'blob' }).pipe(
      catchError(this.handleError)
    );
  }

  API_GET_OtenerParametroRI(){      
    console.log(environment.apiEndpoint  +obtenerParametroRI)
    return this.http.get(environment.apiEndpoint  +obtenerParametroRI, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  API_POST_cambiarParametroRI(estado:number){    
             
    return this.http.post(environment.apiEndpoint + cambiarParametroRI +estado, null, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

      API_POST_activarRI(idJardinPeriodo:number){    
             
    return this.http.post(environment.apiEndpoint + activarRI +idJardinPeriodo, null, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

    API_GET_recuperarPassword(rbd:number){      
    console.log(environment.apiEndpoint  +recuperarPassword)
    return this.http.get(environment.apiEndpoint  +recuperarPassword+rbd, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

    API_POST_actualizarFechasActualizacionDocumento(proyectoEducativoFechasActualizacionData: ProyectoEducativoFechasActualizacionModel) {
    return this.http.post(environment.apiEndpoint + jardinName + 'proyectoEducativo/actualizarFechasActualizacion', proyectoEducativoFechasActualizacionData, httpOptions).pipe(
      catchError(this.handleError)
    );
    
  }

    API_GET_selectFechasActualizacionDocumento(idJardin:number) {
    return this.http.get(environment.apiEndpoint + jardinName + 'proyectoEducativo/selectFechas/'+idJardin, httpOptions).pipe(
      catchError(this.handleError)
    );
    
  }
}
